/**
 * FNV-1a 32-bit hash (plan §0.2).
 * offset 2166136261, prime 16777619, result `>>> 0`.
 */
const FNV_OFFSET = 2166136261;
const FNV_PRIME = 16777619;

/* eslint-disable functional/no-let, functional/no-loop-statements -- tight hash loop */
export function fnv1a(input: string): number {
  /* Index walk matches demo charCodeAt (UTF-16 code units), not code points. */
  let h = FNV_OFFSET;
  for (let i = 0; i < input.length; i++) {
    h = Math.imul(h ^ input.charCodeAt(i), FNV_PRIME) >>> 0;
  }
  return h;
}
/* eslint-enable functional/no-let, functional/no-loop-statements */
